import { createAction } from "@reduxjs/toolkit";
import { Notification, Notifications } from "./state";

export const clearNotifcationsState = createAction("notifcations/clearState");

export const setNewNotifications = createAction<{ data: Notification[] }>(
  "notifcations/setNewNotifications"
);
